import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { estApi } from "../lib/api";

const money = (v) =>
  `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function PriceHistoryDialog({ open, onOpenChange, item }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!open || !item?.id) return;
    estApi.getItemHistory(item.id).then(setRows).catch(() => setRows([]));
  }, [open, item]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="price-history-dialog">
        <DialogHeader>
          <DialogTitle>Price History</DialogTitle>
          <DialogDescription>{item?.name}</DialogDescription>
        </DialogHeader>
        <div className="max-h-72 overflow-auto rounded-md border border-slate-200">
          <table className="w-full text-xs">
            <thead className="bg-slate-50 sticky top-0">
              <tr>
                {["When", "Old", "New", "Change", "User"].map((h) => (
                  <th key={h} className="px-3 py-2 text-left font-medium text-slate-500">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && (
                <tr><td colSpan={5} className="px-3 py-6 text-center text-slate-400">
                  No price changes recorded yet.
                </td></tr>
              )}
              {rows.map((r) => {
                const delta = (r.new_cost || 0) - (r.old_cost || 0);
                return (
                  <tr key={r.id} className="border-t border-slate-100" data-testid={`history-row-${r.id}`}>
                    <td className="px-3 py-1.5 text-slate-600">{new Date(r.changed_at).toLocaleString()}</td>
                    <td className="px-3 py-1.5 text-slate-500">{money(r.old_cost)}</td>
                    <td className="px-3 py-1.5 text-slate-800">{money(r.new_cost)}</td>
                    <td className={`px-3 py-1.5 ${delta >= 0 ? "text-emerald-600" : "text-red-600"}`}>
                      {delta >= 0 ? "+" : ""}{money(delta)}
                    </td>
                    <td className="px-3 py-1.5 text-slate-500">{r.user_email}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </DialogContent>
    </Dialog>
  );
}
